import React from 'react'
import styles from './CitationCard.module.scss'
import { useCitationInformation } from 'modules/website/hooks/useCitationInformation';
import { Placeholder } from 'react-bootstrap';
export default function CitationCard(props) {
    const { data } = props
    //console.log(data)
    //remove first / on data.id
    /* const alias = data.id.replace(data.id[0], '');
    const { isLoading, isError, payload, error } = useCitationInformation({
        alias: alias
    }); */
    //console.log(payload)
    /* if (isLoading) {
        return (
            <Placeholder as="p" animation="wave">
                <Placeholder xs={7} size="sm" /> <Placeholder xs={4} size="sm" />
                <Placeholder xs={4} size="sm" /> <Placeholder xs={7} size="sm" />
                <Placeholder xs={8} size="sm" /> <Placeholder xs={3} size="sm" />
                <Placeholder xs={3} size="sm" /> <Placeholder xs={3} size="sm" /> <Placeholder xs={3} size="sm" /> <Placeholder xs={1} size="sm" />
            </Placeholder>
        )
    }
    if (isError) {
        return (
            <div className={styles.result}></div>
        )
    }
    if (payload) {
 */
    return (
        /* <div className={styles.result}>
            {
                payload.authors.map((author, index) => {
                    if (index < payload.authors.length - 1) {
                        return author.lastname + ", " + author.name + "; "
                    } else {
                        return author.lastname + ", " + author.name + "/ "
                    }
                })
            } 
            {payload.year}.

            "<a href={data.id}>{payload.title}</a>."
            <em>The Journal of Private Enterprise</em> {payload.volume}({payload.number})
        </div> */
        /* <div className={styles.result}>
            {data.citation_authors.map((author, index) =>
                `${author}${index < data.citation_authors.length - 1 ? '; ' : ' / '}`
            ).join('')}
            {data.year}. "<a href={data.id}>{data.id}</a>." <em>The Journal of Private Enterprise</em> {data.volume}({data.number}): {data.pages}
        </div> */
        <div className={styles.result}>
            {Array.isArray(data.citation_authors)
                ? data.citation_authors.map((author, index) =>
                    `${author}${index < data.citation_authors.length - 1 ? '; ' : ' / '}`
                ).join('')
                : `${data.citation_authors} / `
            }
            {data.year}. "<a href={data.id}>{data.title}</a>." <em>The Journal of Private Enterprise</em> {data.volume}({data.number}): {data.pages}
        </div>

    )
    //}
}
